/**
 * @param {File} file 对象
 * @return {Promise<any>}
 */
export function readAsArrayBuffer(file) {
  const fileReader = new FileReader()

  return new Promise((resolve, reject) => {
    const handleFileLoad = e => {
      if (file.size !== e.target.result.byteLength) {
        reject(
          new Error(
            'Browser reported success but could not read the file until the end.'
          )
        )
        fileReader.abort()
        return
      }
      resolve(e.target.result)
    }

    const handleFileError = () => {
      reject(
        new Error(
          'FileReader onerror was triggered, maybe the browser aborted due to high memory usage.'
        )
      )
      fileReader.abort()
    }

    fileReader.readAsArrayBuffer(file)
    fileReader.onload = handleFileLoad
    fileReader.onerror = handleFileError
  })
}

/**
 * @param {File} file 对象
 * @return {Promise<any>}
 */
export function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function(file) {
      resolve(file)
    }
    reader.onerror = function(event) {
      reader.abort()
      reject(event)
    }
  })
}
